import { Button } from "@material-ui/core";

import classes from "./AgentButton.module.css";

const getStyleByVariant = (variant) => {
  switch (variant) {
    case "online":
      return {
        icon: (
          <i className="fas fa-wifi" style={{ transform: "rotate(45deg)" }}></i>
        ),
        color: "#69A100",
      };
    case "ready":
      return {
        icon: <i className="fas fa-phone-volume"></i>,
        color: "#D00010",
      };
    case "working":
      return {
        icon: <i className="fas fa-headphones"></i>,
        color: "#2A75DC",
      };
    case "busy":
      return {
        icon: <i className="far fa-frown"></i>,
        color: "#808088",
      };
    case "pause":
      return {
        icon: <i className="fas fa-ban"></i>,
        color: "#FBDB00",
      };
    case "eating":
      return {
        icon: <i className="fas fa-phone-alt"></i>,
        color: "#ABAB64",
      };
    default:
      break;
  }
};

const AgentButton = ({
  title,
  value,
  onClick,
  disabled,
  blur,
  active,
  variant,
}) => {
  const buttonStyle = getStyleByVariant(variant);

  return (
    <Button
      onClick={onClick}
      classes={{
        root: classes.button,
      }}
      style={{
        ...(buttonStyle?.color && { backgroundColor: buttonStyle.color }),
        ...(blur && { opacity: 0.2 }),
        ...(active && { transform: "scale(1.05)" }),
      }}
      disabled={disabled}>
      <span className={classes.icon}>{buttonStyle?.icon}</span>
      <div className={classes.content}>
        <div className={classes.title}>{title}</div>
        <div>{value}</div>
      </div>
    </Button>
  );
};

export default AgentButton;
